import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8b517e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-line-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips-box" }, "收费活动需要用户先支付，免费活动报名即进入下一步", -1))
const _hoisted_3 = { class: "switch-line-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips-box" }, "0 表示不限名额，按份数占用；已报满时不能再审核通过", -1))
const _hoisted_5 = { class: "switch-line-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips-box" }, "开启后报名要后台审核通过才算成功，否则报名即成功", -1))
const _hoisted_7 = { class: "switch-line-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips-box" }, "停用后前台不再展示该活动", -1))
const _hoisted_9 = { class: "switch-line-box" }
const _hoisted_10 = { class: "tips-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_12 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_ui_switch = _resolveComponent("ui-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_field_list = _resolveComponent("field-list")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, null, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        ref: "form",
        "label-position": "right",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "基本信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, {
                label: "登记名称",
                required: true,
                data: _ctx.formData.name,
                error: "请输入登记名称"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                    maxlength: "25",
                    placeholder: "请输入登记名称",
                    style: {"max-width":"400px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, { label: "登记描述" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.description) = $event)),
                    type: "textarea",
                    maxlength: "200",
                    "show-word-limit": "",
                    placeholder: "报名页顶部的活动说明",
                    style: {"max-width":"400px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, { label: "是否收费" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_ui_switch, {
                      trueValue: 1,
                      falseValue: 0,
                      modelValue: _ctx.formData.isPaid,
                      "onUpdate:modelValue": _ctx.changeIsPaid
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _hoisted_2
                  ])
                ]),
                _: 1
              }),
              (_ctx.formData.isPaid == 1)
                ? (_openBlock(), _createBlock(_component_ui_form_item, {
                    key: 0,
                    label: "报名费",
                    required: true,
                    data: _ctx.formData.price,
                    error: "请填写大于0的报名费"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.formData.price,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.price) = $event)),
                        min: 0.01,
                        precision: 2,
                        step: 1,
                        "controls-position": "right",
                        style: {"width":"200px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ui_form_item, { label: "名额上限" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.formData.maxCount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.maxCount) = $event)),
                      min: 0,
                      "controls-position": "right",
                      style: {"width":"200px"}
                    }, null, 8, ["modelValue"]),
                    _hoisted_4
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, { label: "需要审核" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_ui_switch, {
                      trueValue: 1,
                      falseValue: 0,
                      modelValue: _ctx.formData.isCheck,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.isCheck = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_6
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, { label: "是否启用" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ui_switch, {
                      trueValue: 1,
                      falseValue: 0,
                      modelValue: _ctx.formData.isEnabled,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.isEnabled = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_8
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "报名字段" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, {
                required: true,
                data: _ctx.formData.rowList,
                error: "请至少添加一个报名字段"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_field_list, {
                    modelValue: _ctx.formData.rowList,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.rowList) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "活动渲染模板" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, { label: "渲染模板" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_button, { onClick: _ctx.editTemplate }, {
                      default: _withCtx(() => [
                        _createTextVNode("去装修")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.templateTips), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}